import { render, staticRenderFns } from "./productChoice.vue?vue&type=template&id=3d3f919b&scoped=true&"
import script from "./productChoice.vue?vue&type=script&lang=js&"
export * from "./productChoice.vue?vue&type=script&lang=js&"
import style0 from "./productChoice.vue?vue&type=style&index=0&id=3d3f919b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3f919b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d3f919b')) {
      api.createRecord('3d3f919b', component.options)
    } else {
      api.reload('3d3f919b', component.options)
    }
    module.hot.accept("./productChoice.vue?vue&type=template&id=3d3f919b&scoped=true&", function () {
      api.rerender('3d3f919b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/productChoice.vue"
export default component.exports